import { Link, Navigate } from 'react-router-dom'
import { hasValidSession } from '../lib/api'
import { AuthShell } from '../components/AuthShell'

export function LandingPage() {
  if (hasValidSession()) {
    return <Navigate to="/cuenta" replace />
  }

  return (
    <AuthShell brandLayout="header">
      <div className="auth-card">
        <p className="auth-eyebrow">SateLab</p>
        <h1 className="auth-title">Login centralizado</h1>
        <p className="auth-subtitle">
          Inicia sesión aquí para acceder a los servicios del ecosistema SateLab.
        </p>
        <Link to="/login" className="auth-button">
          Iniciar sesión
        </Link>
      </div>
    </AuthShell>
  )
}
